var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGif = function SvgGif(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A066AA",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.468 17.539c-.426.353-.948.504-1.476.504-1.26 0-2.153-.72-2.153-2.147 0-1.212.942-2.153 2.207-2.153.474 0 .995.162 1.367.528.366.36-.162.893-.521.576-.222-.217-.534-.378-.846-.378-.726 0-1.427.581-1.427 1.427 0 .887.587 1.427 1.373 1.427.366 0 .678-.108.9-.27v-.737h-.9c-.534 0-.48-.732 0-.732h1.2c.222 0 .425.168.425.354v1.277c0 .108-.047.209-.15.324M10.644 14.21c0-.492.792-.51.792 0v3.423c0 .498-.792.51-.792 0zM13.278 14.63v.953h1.528c.216 0 .432.216.432.426 0 .198-.216.359-.432.359h-1.528v1.26c0 .21-.15.371-.36.371-.264 0-.426-.162-.426-.372v-3.405c0-.216.162-.372.426-.372h2.105c.264 0 .42.155.42.372a.414.414 0 0 1-.42.407h-1.745"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgGif;